// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-company-contacts-indexstyleMobileGrid-container-cbmix{margin:0 auto;padding:0 16px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-company-contacts-indexstyleMobileGrid-container-cbmix"
};
module.exports = ___CSS_LOADER_EXPORT___;
